var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "post-operations-section-wrapper" },
    [
      _c("div", { staticClass: "section-header" }, [
        _c("h4", [_vm._v(_vm._s(_vm.$t("message.postOperations")))]),
      ]),
      _vm._v(" "),
      _vm.postOperations.length
        ? _c(
            "div",
            { staticClass: "post-operations-section" },
            _vm._l(_vm.postOperations, function (postOp) {
              return _c(
                "div",
                {
                  key: postOp.id,
                  staticClass: "post-op-row",
                  on: {
                    click: function ($event) {
                      return _vm.handlePostOpClick(postOp)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "post-op-info" }, [
                    _c("div", { staticClass: "post-op-status" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("event_available"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(postOp.Operation_Statu))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "post-op-owner" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("person"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$_.get(postOp, "Owner.name", ""))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "post-op-date" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("event"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(postOp.Operation_Date))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "post-op-contact" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("contacts"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$_.get(postOp, "Contact.name", ""))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("SupsisButton", {
                    staticClass: "view-post-op-btn",
                    attrs: { icon: "open_in_new" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.gotoPostOperationOnZoho(postOp.id)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("a-divider"),
                ],
                1
              )
            }),
            0
          )
        : _vm.loading
        ? _c(
            "div",
            { staticClass: "loading-container" },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("message.loadingPostOperations"))),
              ]),
              _vm._v(" "),
              _c("BucketSpinner", { staticClass: "large-spinner" }),
            ],
            1
          )
        : _c("div", { staticClass: "empty-post-ops-container" }, [
            _c("span", { staticClass: "material-icons empty-icon" }, [
              _vm._v("event_busy"),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "empty-text" }, [
              _vm._v(_vm._s(_vm.$t("message.noPostOperations"))),
            ]),
          ]),
      _vm._v(" "),
      _vm.selectedPostOp
        ? _c(
            "Modal2",
            {
              attrs: {
                visible: !!_vm.selectedPostOp,
                title: "$t('message.postOperationDetails')",
                footer: null,
                className: "post-op-viewer-modal",
              },
              on: { cancel: _vm.handleModalClose },
            },
            [_c("PostOpViewer", { attrs: { postOp: _vm.selectedPostOp } })],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }